module.exports = __webpack_public_path__ + "img/k5.021d6eaf.jpg";